function Message(options) {
  options = options || {};
  this.type = options.type || 'error';
  this.scope = options.scope || 'system';
  this.messageKey = options.messageKey;
  this.messageParams = options.messageParams || {};
  this.message = options.message;
  this.category = options.category;
}

export default {
  create: function (options) {
    return new Message(options);
  }
};
